import { all, fork } from 'redux-saga/effects'

import getGeoSaga from './sagas/getGeo'

function* LocationService() {
  yield all([fork(getGeoSaga)])
}

export default LocationService
